import Vue from "vue";
import * as FilterFunctions from "./filterFunctions";

//用户来源（全部）
Vue.filter("userForm", FilterFunctions.userForm);

// // App用户
Vue.filter('userFormApp', FilterFunctions.userFormApp);

// // 订单状态
Vue.filter('orderType', FilterFunctions.orderType);
//兔管家订单状态
Vue.filter('rabbitType', FilterFunctions.rabbitType);
// // 运单状态
Vue.filter('skipType', FilterFunctions.skipType);

// 交易类型
Vue.filter('dealType', FilterFunctions.dealType);
// 物流管理 运单状态
Vue.filter('waybillType', FilterFunctions.waybillType);
// 包裹状态
Vue.filter('packType', FilterFunctions.packType);
// 物流运单
Vue.filter('wuLiuType', FilterFunctions.wuLiuType);
// 包裹列表状态
Vue.filter('baoLtYPE', FilterFunctions.baoLtYPE);


